// removed by extract-text-webpack-plugin
module.exports = {"modal__body":"ModalChangeClub-module__modal__body___1Y35O","modal__title":"ModalChangeClub-module__modal__title___2WsN9","modal__content":"ModalChangeClub-module__modal__content___30zYT","modal__actions":"ModalChangeClub-module__modal__actions___2Iu5P","modal__action":"ModalChangeClub-module__modal__action___1POnQ","modal__link__primary":"ModalChangeClub-module__modal__link__primary___3yfX3"};


//////////////////
// WEBPACK FOOTER
// ./src/app/components/ModalChangeClub/ModalChangeClub.module.css
// module id = 635
// module chunks = 0